/**
 * CBT thinking-pattern labels for Quick Clarity (AI / internal tier).
 * UI may show the label; keys are stored for reporting.
 */

export const CBT_THINKING_PATTERN_KEYS = [
  "catastrophizing",
  "mind_reading",
  "fortune_telling",
  "all_or_nothing",
  "overgeneralization",
  "personalization",
  "labeling",
  "emotional_reasoning",
  "should_statements",
  "mental_filtering",
  "discounting_the_positive"
];

export const CBT_THINKING_PATTERNS = {
  catastrophizing: {
    key: "catastrophizing",
    label: "Catastrophizing"
  },
  mind_reading: {
    key: "mind_reading",
    label: "Mind-reading"
  },
  fortune_telling: {
    key: "fortune_telling",
    label: "Fortune-telling"
  },
  all_or_nothing: {
    key: "all_or_nothing",
    label: "All-or-nothing thinking"
  },
  overgeneralization: {
    key: "overgeneralization",
    label: "Overgeneralization"
  },
  personalization: {
    key: "personalization",
    label: "Personalization"
  },
  labeling: {
    key: "labeling",
    label: "Labeling"
  },
  emotional_reasoning: {
    key: "emotional_reasoning",
    label: "Emotional reasoning"
  },
  should_statements: {
    key: "should_statements",
    label: "Should statements"
  },
  mental_filtering: {
    key: "mental_filtering",
    label: "Mental filtering"
  },
  discounting_the_positive: {
    key: "discounting_the_positive",
    label: "Discounting the positive"
  }
};

export function canonicalCbtThinkingPattern(value) {
  if (value == null || value === "") return "";
  const raw = String(value).trim();
  if (!raw) return "";
  const asKey = raw.toLowerCase().replace(/[\s-]+/g, "_");
  if (CBT_THINKING_PATTERNS[asKey]) return asKey;
  const byLabel = CBT_THINKING_PATTERN_KEYS.find(
    (k) => CBT_THINKING_PATTERNS[k].label.toLowerCase() === raw.toLowerCase()
  );
  return byLabel || "";
}

export function getCbtThinkingPatternMeta(keyOrLabel) {
  const key = canonicalCbtThinkingPattern(keyOrLabel);
  if (!key) return null;
  return CBT_THINKING_PATTERNS[key];
}

export function buildCbtThinkingPatternsPromptSection() {
  return CBT_THINKING_PATTERN_KEYS.map((k) => {
    const p = CBT_THINKING_PATTERNS[k];
    return `- ${p.key} → label "${p.label}"`;
  }).join("\n");
}
